import React, { useState } from "react";
import "./NewCC.css";
import { toast } from "react-toastify";

const NewCC = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    inquiryPhone: "",
    dob: "",
    inquiryPurpose: "",
    aadhar: "",
    pan: "",
    voter: "",
    passport: "",
    ration: "",
    driver: "",
    other: "",
    addressType: "Home",
    addressLine: "",
    state: "",
    pinCode: "",
    nameType: "",
    name: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.success("Form submitted successfully!");
  };

  return (
    <div className="Newcccredit-form-container">
      <form className="Newcccredit-form" onSubmit={handleSubmit}>
        {/* Basic Info */}
        <div className="Newccform-row">
          <div className="Newccform-group">
            <label>Full Name</label>
            <input
              type="text"
              name="fullName"
              placeholder="Enter Full Name"
              onChange={handleChange}
            />
          </div>
          <div className="Newccform-group">
            <label>Inquiry Phone</label>
            <input
              type="text"
              name="inquiryPhone"
              placeholder="Enter Inquiry Phone"
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="Newccform-row">
          <div className="Newccform-group">
            <label>Date of Birth</label>
            <input
              type="date"
              name="dob"
              onChange={handleChange}
            />
          </div>
          <div className="Newccform-group">
            <label>Inquiry Purpose</label>
            <select name="inquiryPurpose" onChange={handleChange}>
              <option value="">Select Purpose</option>
              <option value="loan">Loan</option>
              <option value="credit">Credit Card</option>
              <option value="others">Others</option>
            </select>
          </div>
        </div>

        {/* ID Details */}
        <fieldset className="Newccfieldset">
          <legend>KYC Details</legend>
          <div className="Newccform-row">
            <input
              type="text"
              name="aadhar"
              placeholder="Enter Aadhar Number"
              onChange={handleChange}
            />
            <input
              type="text"
              name="pan"
              placeholder="Enter PAN Number"
              onChange={handleChange}
            />
            <input
              type="text"
              name="voter"
              placeholder="Enter Voter ID"
              onChange={handleChange}
            />
          </div>
          <div className="Newccform-row">
            <input
              type="text"
              name="passport"
              placeholder="Enter Passport ID"
              onChange={handleChange}
            />
            <input
              type="text"
              name="ration"
              placeholder="Enter Ration Card Number"
              onChange={handleChange}
            />
            <input
              type="text"
              name="driver"
              placeholder="Enter Driver License Number"
              onChange={handleChange}
            />
          </div>
          
          <p className="Newccnote">⚠️ Note: Provide at least one ID.</p>
        </fieldset>

        {/* Inquiry Address */}
        <fieldset className="Newccfieldset">
          <legend>Inquiry Address</legend>
          <div className="Newccform-row">
            <select name="addressType" onChange={handleChange}>
              <option value="Home">Home</option>
              <option value="Office">Office</option>
            </select>
            <input
              type="text"
              name="addressLine"
              placeholder="Enter Address"
              onChange={handleChange}
            />
          </div>
          <div className="Newccform-row">
            <select name="state" onChange={handleChange}>
              <option value="">Select State</option>
              <option value="Bihar">Bihar</option>
              <option value="UP">Uttar Pradesh</option>
              <option value="Delhi">Delhi</option>
            </select>
            <input
              type="text"
              name="pinCode"
              placeholder="Enter Pin Code"
              onChange={handleChange}
            />
          </div>
        </fieldset>

        {/* MFI Details */}
        <fieldset className="Newccfieldset">
          <legend>Parent's Details</legend>
          <div className="Newccform-row">
            <select name="nameType" onChange={handleChange}>
              <option value="">Select Name Type</option>
              <option value="primary">Primary</option>
              <option value="secondary">Secondary</option>
            </select>
            <input
              type="text"
              name="name"
              placeholder="Enter Name"
              onChange={handleChange}
            />
          </div>
        </fieldset>

        <button type="submit" className="Newccsubmit-btn">
          🚀 Fetch Credit Score
        </button>
      </form>
    </div>
  );
};

export default NewCC;
